var map = {
	"./assets/background/stripe_background.jpg": "fec6",
	"./assets/bank/baac.svg": "5671",
	"./assets/bank/bay.svg": "aa82",
	"./assets/bank/bbl.svg": "b91c",
	"./assets/bank/bnp.svg": "653f",
	"./assets/bank/boa.svg": "81cd",
	"./assets/bank/cacib.svg": "7bf0",
	"./assets/bank/cimb.svg": "3c69",
	"./assets/bank/citi.svg": "a931",
	"./assets/bank/db.svg": "bde3",
	"./assets/bank/ghb.svg": "e1f4",
	"./assets/bank/gsb.svg": "3f6b",
	"./assets/bank/hsbc.svg": "31d4",
	"./assets/bank/ibank.svg": "cfec",
	"./assets/bank/icbc.svg": "aa9c",
	"./assets/bank/jpm.svg": "8054",
	"./assets/bank/kbank.svg": "7f96",
	"./assets/bank/kk.svg": "d1f5",
	"./assets/bank/ktb.svg": "634b",
	"./assets/bank/lhb.svg": "62a3",
	"./assets/bank/mb.svg": "9ef2",
	"./assets/bank/mega.svg": "fbcf",
	"./assets/bank/mufg.svg": "97ef",
	"./assets/bank/rbs.svg": "5c52",
	"./assets/bank/sc.svg": "56b8",
	"./assets/bank/scb.svg": "3191",
	"./assets/bank/smbc.svg": "452a",
	"./assets/bank/tbank.svg": "3c52",
	"./assets/bank/tcrb.svg": "2c8a",
	"./assets/bank/tisco.svg": "37e5",
	"./assets/bank/tmb.svg": "2c3d",
	"./assets/bank/truemoney.svg": "edc9",
	"./assets/bank/ttb.svg": "171b",
	"./assets/bank/uob.svg": "1f63",
	"./assets/banner/casino.jpg": "19e5",
	"./assets/banner/casual.jpg": "f097",
	"./assets/banner/fishing.jpg": "488c",
	"./assets/banner/man--mobile.jpg": "4db5",
	"./assets/banner/man.jpg": "b3aa",
	"./assets/banner/p2p.jpg": "e3b9",
	"./assets/banner/slot.jpg": "f13f",
	"./assets/bonus-cny.png": "d982",
	"./assets/bonus-valentine.png": "9f46",
	"./assets/bonus.png": "7eeb",
	"./assets/casino_banner/Dream gaming.jpg": "cc7d",
	"./assets/casino_banner/N2-Live.jpg": "119f",
	"./assets/casino_banner/SA gaming.jpg": "a1e6",
	"./assets/casino_banner/Sexy Gaming.jpg": "0fa9",
	"./assets/casino_banner/WM casino.jpg": "df32",
	"./assets/casual_banner/Ace Round.jpg": "2383",
	"./assets/casual_banner/Atlantis.jpg": "2b2a",
	"./assets/casual_banner/Courier Sweeper.jpg": "45b0",
	"./assets/casual_banner/Crown _ Anchor.jpg": "5540",
	"./assets/casual_banner/Dungeon.jpg": "5908",
	"./assets/casual_banner/E.T. Races.jpg": "97cd",
	"./assets/casual_banner/Fruit Burst.jpg": "d732",
	"./assets/casual_banner/Heads _ Tails.jpg": "0e9d",
	"./assets/casual_banner/Mafia Syndicate.jpg": "e501",
	"./assets/casual_banner/Maze.jpg": "639a",
	"./assets/casual_banner/Rise of Horus.jpg": "bd75",
	"./assets/casual_banner/Roll the Dice.jpg": "fdf8",
	"./assets/casual_banner/Surf zone.jpg": "28ee",
	"./assets/casual_banner/Temple of dead.jpg": "2ac6",
	"./assets/casual_banner/Treasure Mania.jpg": "9340",
	"./assets/contact-qr.png": "3ec0",
	"./assets/default_banner.png": "564a",
	"./assets/fishing_banner/Fisherman Gold.jpg": "ae8d",
	"./assets/fishing_banner/Moster Awaken.jpg": "529d",
	"./assets/fishing_banner/Tokyo Kombat.jpg": "b210",
	"./assets/fishing_banner/fish haiba.jpg": "54fc",
	"./assets/fishing_banner/fish hunter spongebob.jpg": "21f8",
	"./assets/games/background.jpg": "7679",
	"./assets/games/deadwood.jpg": "2e67f",
	"./assets/games/ironbank.jpg": "0cb2",
	"./assets/games/moneytrain2.jpg": "efb4",
	"./assets/games/pokdeng.jpg": "2a89",
	"./assets/games/thor.jpg": "db05",
	"./assets/games/vikings.jpg": "5012",
	"./assets/icons/base-logo.svg": "2749",
	"./assets/icons/caret-right.svg": "138f",
	"./assets/icons/casino.png": "2687",
	"./assets/icons/casual.png": "7cad",
	"./assets/icons/coin.png": "f4d2",
	"./assets/icons/crown.png": "e599",
	"./assets/icons/deposit.png": "dcd0",
	"./assets/icons/dice.png": "aa39",
	"./assets/icons/fishing.png": "2b34",
	"./assets/icons/game.png": "9fcd",
	"./assets/icons/login.png": "0d6b",
	"./assets/icons/otp.png": "e548",
	"./assets/icons/p2p.png": "297b",
	"./assets/icons/password.png": "5d06",
	"./assets/icons/promotion.png": "c255",
	"./assets/icons/slot.png": "c8a3",
	"./assets/icons/support.png": "60b9",
	"./assets/indicator.png": "588b",
	"./assets/p2p_banner/Bingo.jpg": "5d4f",
	"./assets/p2p_banner/Hilo.jpg": "dbed",
	"./assets/p2p_banner/Kang.jpg": "32f9",
	"./assets/p2p_banner/Namtaopupa.jpg": "b2ea",
	"./assets/p2p_banner/Pokdeng.jpg": "a8aa",
	"./assets/promotions/Pro-08.jpg": "40e2",
	"./assets/promotions/Pro-09.jpg": "fa25",
	"./assets/promotions/Pro-10.jpg": "bdb3",
	"./assets/promotions/Pro-11.jpg": "0c63",
	"./assets/promotions/Pro-12.jpg": "6130",
	"./assets/promotions/Pro-13.jpg": "8afe",
	"./assets/promotions/Pro-money truck-desktop.jpg": "3755",
	"./assets/promotions/Pro-money truck-mobile.jpg": "57ca",
	"./assets/roulette.png": "fa26",
	"./assets/slot_banner/caishen_wins.jpg": "9b3a",
	"./assets/slot_banner/deadwood.jpg": "bc69",
	"./assets/slot_banner/dragon_tiger.jpg": "7ccd",
	"./assets/slot_banner/egypt_s_book_of_mystery.jpg": "349b",
	"./assets/slot_banner/four_dragons.jpg": "bd07",
	"./assets/slot_banner/genie_jackpots.jpg": "fb64",
	"./assets/slot_banner/iron_bank.jpg": "eb10",
	"./assets/slot_banner/money_train2.jpg": "537c",
	"./assets/slot_banner/ramses_revenge.jpg": "63e9",
	"./assets/slot_banner/roma.jpg": "6db0",
	"./assets/slot_banner/sanquentin.jpg": "235a",
	"./assets/slot_banner/sweet_bonanza.jpg": "dbd9",
	"./assets/slot_banner/thor.jpg": "4d28",
	"./assets/slot_banner/vikings.jpg": "411a",
	"./assets/slot_banner/wild_west.jpg": "2166",
	"./assets/studio_banner/blueprint.jpg": "25c4",
	"./assets/studio_banner/dream_gaming.jpg": "095e",
	"./assets/studio_banner/joker.jpg": "363b",
	"./assets/studio_banner/pg.jpg": "0e2f",
	"./assets/studio_banner/sa.jpg": "c0d2",
	"./assets/studio_logos/ag.png": "7633",
	"./assets/studio_logos/betsoft.png": "6780",
	"./assets/studio_logos/bg.png": "72ab",
	"./assets/studio_logos/blueprint.png": "03ac",
	"./assets/studio_logos/dream_gamming.png": "9e18",
	"./assets/studio_logos/evoplay.png": "26f8",
	"./assets/studio_logos/funky_play.png": "fd42",
	"./assets/studio_logos/gamatron.png": "54cb",
	"./assets/studio_logos/gameplay.png": "3073",
	"./assets/studio_logos/gdg.png": "6542",
	"./assets/studio_logos/gg_fishing.png": "94f3",
	"./assets/studio_logos/green_dragon.png": "3d0a",
	"./assets/studio_logos/habanero.png": "0ef6",
	"./assets/studio_logos/iron_dog.png": "45ac",
	"./assets/studio_logos/joker.png": "9b82",
	"./assets/studio_logos/kalamba.png": "7c05",
	"./assets/studio_logos/maverick.png": "91cb",
	"./assets/studio_logos/microgaming.png": "6e17",
	"./assets/studio_logos/n2.png": "e2fa",
	"./assets/studio_logos/pg.png": "6ec6",
	"./assets/studio_logos/playstart.png": "2ccd",
	"./assets/studio_logos/pragmatic.png": "7a08",
	"./assets/studio_logos/quickspin.png": "770a",
	"./assets/studio_logos/red_tiger.png": "c7b4",
	"./assets/studio_logos/relax_gaming.png": "22d3",
	"./assets/studio_logos/sa.png": "63c5",
	"./assets/studio_logos/sexy_gaming.png": "0d4d",
	"./assets/studio_logos/simpleplay.png": "8dfc",
	"./assets/studio_logos/toptrend.png": "9576",
	"./assets/studio_logos/wm.png": "3b99",
	"./assets/studio_logos/yggdrasil.png": "1afc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";